<style lang="scss" scoped="scoped">
	p {
		color: #303133;
	}

	.reason::-webkit-scrollbar {
		display: none;
	}
</style>
<style lang="scss">
	
	.alert_reason .el-select .el-input{
		width: auto;
	}
	.alert_reason .el-input__inner {
		color: #606266;
		border: none;
		background-color: transparent;
		text-align: right;
		width: 150px;
		
	}
</style>


<template>
	<div class="alert_reason" ref="container"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;padding-right: 0px;display: flex;flex-direction: column;justify-content: space-between;">
		<div ref="titleBar" class="titleBar"
			style="flex-shrink: 0;display: flex;align-items: center;justify-content: space-between;">
			<p style="font-size: 16px;font-weight: 700;flex-shrink: 0;">
				{{$t('tingjiyuanyinpaiming')}}
			</p>
			<!-- 909399 12px -->
			<div
				style="height: 22px;background: white;display: flex;align-items: center;margin-right: 10px;">
				<el-select v-model="type" :placeholder="$t('qingxuanze')" style="color: #909399;font-size: 14px;">
					<el-option :key="$t('jin7rishuju')" :label="$t('jin7rishuju')" :value="7">
					</el-option>
					<el-option :key="$t('jin14rishuju')" :label="$t('jin14rishuju')" :value="14">
					</el-option>
					<el-option :key="$t('jin30rishuju')" :label="$t('jin30rishuju')" :value="30">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="reason"
			style="flex: 1;display: flex;flex-direction: column;justify-content: flex-start;margin-top: 20px;overflow: auto;">

			<div v-for="(reason,index) in reasons"
				style="display: flex;justify-content: space-between;margin-bottom: 12px;">
				<div style="display: flex;align-items: center;width: 100%;">
					<div
						style="height: 18px;width: 18px;border-radius: 50%;color: white;background-color: #909399;display: flex;justify-content: center;align-items: center;">
						{{(index+1)}}
					</div>
					<div style="color: #606266;margin-left: 8px;width: 120px;overflow: hidden">
						{{reason.typeName?($t(reason.typeName)+':'):''}}{{reason.typeName?reason.reasonName:$t(reason.reasonName)}}
					</div>
					<div
						style="color: #606266;margin-left: 8px;flex: 1;display: flex;align-items: center;margin-left: 12px ;margin-right: 10px;">
						<div style="height: 8px;background-color: #419FFF;" :style="{width:percent(reason.count)}"></div>
						<div style="flex-shrink: 0;margin-left: 12px ;">{{(reason.count/3600).toFixed(1)}}h</div>
					</div>
				</div>

			</div>

		</div>



	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_home_reason',
		components: {

		},

		data() {
			return {
				timmer: null,
				type: 7,
				reasons: [],
			};
		},
		computed: {
			percent() {
				return (count)=>{
					let max = 0
					for (var i = 0; i < this.reasons.length; i++) {
						if(this.reasons[i].count>max){
							max = this.reasons[i].count
						}
					}
					
					return (count/max*100+"%")
				}
				
			}
		},
		created() {
			// this.timmer = setInterval(() => {
			// 	this.getEquipmentException()
			// }, 120000)
			this.getEquipmentException()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.getEquipmentException()
			},
			type(n, o) {
				this.getEquipmentException();
			},
			



		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			async getEquipmentException() {
				let response = await this.http.get('/web/equipment/home/getEquipmentException', {
					params: {
						orgId: this.$attrs.orgId,
						type: this.type
					}
				})
				this.reasons = response.data

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				// setTimeout(() => {
				// 	this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
				// 		20 - 20
				// }, 800)



			},

		}
	};
</script>
